// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"793c1a8a","294":"fbdd2a19","323":"98b1fe06","332":"368b805b","375":"13317e2f","421":"d4f2d844","451":"69dd2004","453":"2a66fd66","487":"bf19ab3c","496":"e63bb5f5","516":"2e53f513","591":"20a39c00","619":"6e7c209e","773":"d06e20f9","857":"23129cc7","959":"ad9e75fc"}[chunkId] + ".chunk.js";
};